

























































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import accessCard from '../components/access-card.vue'
import accountCard from '../components/account-card.vue'
import {
  getPaymentList,
  getPaymentAccount,
  savePaymentInfo,
  useAccount,
  getPaymentInfo,
  getAccountInfo,
  saveAccountInfo,
  getChannelList,
  saveConfig,
  deleteMerchantAccount,
  payAppSwitch
} from '@/api/payment/payment'

interface config {
  title: string
  id: string | number
  number: number
  icon: string
}

interface accountItem {
  title: string
  email: string
  methods?: string[]
  isUse: number
  id: string
}

@Component({
  name: 'paymentAccount',
  components: {
    accessCard,
    accountCard
  }
})
export default class extends Vue {
  accessList: config[] = []

  editVisible: boolean = false

  editAccountVisible: boolean = false

  accountList: accountItem[] = []

  tabId: number = 1

  isOpen: string = 'off'

  open: number = 0

  configList: any[] = []

  pageInfo = {
    page: 1,
    pageCount: 20
  }

  access: string = ''

  editParams: any = {
    id: 0,
    name: '',
    logo: '',
    description: '',
    code: '',
    currency: '',
    open: 0,
    is_mobile_pay: 0,
    is_html5: 0,
    seq: 0
  }

  accountParams: any = {
    id: 0,
    pay_gate_id: 0,
    account_name: '',
    live_mode: 0,
    app_id: '',
    merchant_id: '',
    merchant_account: '',
    app_key: '',
    app_secret: '',
    app_private_key: '',
    app_public_key: '',
    public_key: '',
    root_cert: '',
    webhook_secret: '',
    is_use: 0,
    is_delete: 0
  }
  // 全局配置
  globalConfig: any = {
    id: 0,
    item_value: 'off'
  }

  created() {
    this.getAccessList()
    this.getConfigList()
  }

  handleSelect({ id, title }: any) {
    let flag: boolean = this.tabId !== id
    this.tabId = id
    this.access = title
    flag && this.getAccountList()
  }

  async handleEdit(id: number) {
    let res: any = await getAccountInfo({ id })
    this.editAccountVisible = true
    const { data } = res
    for (let key in this.accountParams) {
      if (key in data) {
        this.accountParams[key] = data[key]
      }
    }
  }

  handleDelete(id: string) {
    this.$confirm('是否删除？/ 批量删除吗？', '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteMerchantAccount({ id: +id })
        if (+res.status.code === 0) {
          this.$message.success('操作成功')
          await this.getAccountList()
        } else {
          this.$message.warning(res.status.message)
        }
      })
      .catch(() => {})
  }

  handleSwitch({ id }: any) {
    this.$confirm('确认操作吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        await useAccount({ id })
        await this.getAccountList()
      })
      .catch(() => {})
  }

  async getConfigList() {
    let res: any = await getChannelList()
    const {
      data: { dataList }
    } = res
    if (dataList) {
      this.configList = dataList
      // if (dataList[0]) {
      //   this.isOpen = dataList[0]['item_value']
      //   this.switchList = dataList[0]['value_data_list']
      //   this.globalConfig = dataList[0]
      // }
      // if (dataList[1]) {
      //   this.rate = dataList[1]['item_value']
      // }
    }
  }

  handleSaveConfig({ id, value }: any) {
    this.$confirm('确认操作吗?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res:any = await saveConfig({ id, 'item_value': value })
        if (res.status.code === 0) {
          this['$message'].success('操作成功')
          this.getConfigList()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }

  async handleEditAccess(id: number) {
    let res: any = await getPaymentInfo({ id })
    this.editVisible = true
    const { data } = res
    for (let key in this.editParams) {
      if (key in data) {
        this.editParams[key] = data[key]
      }
    }
  }

  handleAdd() {
    this.editParams = {
      id: 0,
      name: '',
      logo: '',
      description: '',
      code: '',
      currency: '',
      open: 0,
      is_mobile_pay: 0,
      is_html5: 0,
      seq: 0
    }
    this.editVisible = true
  }

  addAccount() {
    this.accountParams = {
      id: 0,
      pay_gate_id: this.tabId,
      account_name: '',
      live_mode: 0,
      app_id: '',
      merchant_id: '',
      merchant_account: '',
      app_key: '',
      app_secret: '',
      app_private_key: '',
      app_public_key: '',
      public_key: '',
      root_cert: '',
      webhook_secret: '',
      is_use: 0,
      is_delete: 0
    }
    this.editAccountVisible = true
  }

  async handleSave() {
    for (let key in this.editParams) {
      if (typeof this.editParams[key] === 'string') {
        this.editParams[key] = this.editParams[key].trim()
      }
    }
    if (!this.editParams['name']) return this.$message.warning('请输入支付网关名称')
    if (!this.editParams['code']) return this.$message.warning('请输入支付网关code')
    if (!this.editParams['logo']) return this.$message.warning('请上传支付网关icon')
    if (!this.editParams['currency']) return this.$message.warning('请选择支付网关币种')
    if (typeof this.editParams['seq'] !== 'number') return this.$message.warning('请输入排序号')
    this.editParams.logo = this.editParams.logo.split('?')[0]
    await savePaymentInfo(this.editParams)
    this.$message.success('操作成功')
    this.editVisible = false
    await this.getAccessList()
  }

  async handleSaveAccount() {
    const fields: string[] = ['pay_gate_id', 'account_name']
    for (let key of fields) {
      if (typeof this.accountParams[key] === 'string') {
        this.accountParams[key] = this.accountParams[key].trim()
      }
    }
    if (!this.accountParams['pay_gate_id']) return this.$message.warning('请输入支付网关ID')
    if (!this.accountParams['account_name']) return this.$message.warning('请输入账号名称')
    await saveAccountInfo(this.accountParams)
    this.$message.success('操作成功')
    await this.getAccountList()
    this.editAccountVisible = false
  }

  async getAccountList() {
    let res: any = await getPaymentAccount({ pay_gate_id: this.tabId })
    let index: number = this.accessList.findIndex((item: any) => item.id === this.tabId)
    let dataList: any[] = res.data.dataList
    let item: any = this.accessList[index]
    console.log(item)
    item['number'] = dataList.length
    this.open = item['open']
    this.accountList = dataList.map(
      ({ account_name: title, merchant_account: email, is_use: isUse, id }: any) => {
        return {
          title,
          email,
          // methods: ['api', 'sdk'],
          isUse,
          id
        }
      }
    )
  }

  async getAccessList(id: number = 0) {
    let res: any = await getPaymentList(this.pageInfo)
    const {
      data: { dataList }
    } = res
    this.accessList = dataList.map(({ bank, id, name, logo, account_count: number, open }: any) => {
      return {
        title: name,
        id,
        icon: logo || bank,
        number,
        open
      }
    })
    if (id) {
      this.tabId = id
      this.access = dataList.find((item: any) => item.id === id)['title']
      await this.getAccountList()
    } else {
      let firstOne: config = this.accessList[0]
      if (firstOne) {
        this.tabId = +firstOne.id
        this.access = firstOne.title
        await this.getAccountList()
      }
    }
  }

  async handleOpenOff() {
    let res: any = await payAppSwitch({ id: this.tabId })
    if (+res.status.code === 0) {
      this.$message.success('操作成功')
      await this.getAccessList(this.tabId)
    } else {
      this.$message.warning(res.status.code)
    }
  }
}
